import { render, staticRenderFns } from "./BlockListTable.vue?vue&type=template&id=441a3e0d&"
import script from "./BlockListTable.vue?vue&type=script&lang=js&"
export * from "./BlockListTable.vue?vue&type=script&lang=js&"
import style0 from "./BlockListTable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports